import { MenuState } from '../types';

interface MenuAction {
  type: string;
  menu?: MenuState['menu'];
}

const initialState: MenuState = {
  menu: { menu1: [], menu2: [], menu3: [], menu4: [] },
  loadingMenu: false,
};

const updateMenu = (state: MenuState, action: MenuAction): MenuState => {
  return { ...state, menu: action.menu!, loadingMenu: false };
};

const menuReducer = (state: MenuState = initialState, action: MenuAction): MenuState => {
  switch (action.type) {
    case 'START_FETCHING_MENU':
      return {
        ...state,
        loadingMenu: true,
      };
    case 'UPDATE_MENU':
      return updateMenu(state, action);
    default:
      return state;
  }
};

export default menuReducer;
